import { render, staticRenderFns } from "./footer-body.vue?vue&type=template&id=ecd521a2&scoped=true"
import script from "./footer-body.vue?vue&type=script&lang=js"
export * from "./footer-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd521a2",
  null
  
)

export default component.exports